import { CSSProperties, ReactNode } from 'react';
import capitalize from 'lodash/capitalize';

import BootstrapBadge from 'react-bootstrap/Badge';
import './Badge.scss';

/**
 * Badge is a component for creating a Scalyr version of a Badge button.
 * Badge has next color schemas depending on its variant: info,  success, pending.
 *
 *
 * @param {string}             variant         info | success | pending
 * Optional:
 * @param {string}             className  class(es) to add to Badge
 * @param {Component}   children  the body content of the Badge
 * @param {string}             style CSS variables added for Badge
 *
 * @returns {Component}
 */

type BadgeProps = {
  variant: 'info' | 'success' | 'pending' | 'error' | 'custom' | 'modified';
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
};

export default function Badge({ className, variant, children, style }: BadgeProps): JSX.Element {
  let badgeClass = variant ? 'Badge Badge--' + capitalize(variant) : '';
  if (className) {
    badgeClass += ' ' + className;
  }
  return (
    <BootstrapBadge className={badgeClass} style={style}>
      {children}
    </BootstrapBadge>
  );
}
